var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "hr-sect cursor-pointer",
        class: {
          "text-accent-no": _vm.edit_enable == true
        },
        attrs: { id: "bookmarks_navigation--wrapper-hr" },
        on: {
          click: function($event) {
            _vm.edit_enable = !_vm.edit_enable
          }
        }
      },
      [_vm._v("Bookmarks\n    ")]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "collapsible collapsible-accordion" },
      [
        _vm.items.hasOwnProperty("last_event")
          ? _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "w-100 d-flex align-items-center collapsible-header",
                  attrs: {
                    title: "Last event: " + _vm.items.last_event.title,
                    "data-toggle": "tooltip",
                    href: _vm.route(_vm.items.last_event)
                  }
                },
                [
                  _c("i", { staticClass: "favorite material-icons mr-1" }, [
                    _vm._v("trending_up")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-truncate" }, [
                    _vm._v(_vm._s(_vm.items.last_event.title))
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.items.hasOwnProperty("list")
          ? [
              _vm._l(_vm.items.list, function(item) {
                return [
                  item.hasOwnProperty("route") &&
                  item.hasOwnProperty("bookmark")
                    ? _c("li", [
                        _vm.edit_enable != true
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "w-100 d-flex align-items-center collapsible-header",
                                attrs: {
                                  title: item.route.title,
                                  href: _vm.route(item.route),
                                  "data-toggle": "tooltip"
                                }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "favorite material-icons mr-2"
                                  },
                                  [_vm._v("favorite_border")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.route.title))
                                ])
                              ]
                            )
                          : _c(
                              "a",
                              {
                                staticClass:
                                  "w-100 d-flex align-items-center collapsible-header",
                                attrs: {
                                  title: item.route.title,
                                  "data-toggle": "tooltip"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.removeItem(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons mr-2" },
                                  [_vm._v("delete")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.route.title))
                                ])
                              ]
                            )
                      ])
                    : _c("li", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.route.title) +
                            "\n                "
                        )
                      ])
                ]
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0da3766", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0da3766","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/navigation/bookmarksNavigation.vue
// module id = 414
// module chunks = 0